import request from "@/config/utils/request";

// 列表
// export function getListquery() {
//     return request({
//         url: "/apis/demo/listQuery",
//         method: "get"
//     });
// }
// 编辑
export function editUser(data) {
  return request({
    url: "/apis/demo/userAndEducation/editUser",
    method: "POST",
    data
  });
}
// 添加
export function saveUser(data) {
  return request({
    url: "/apis/demo/userAndEducation/saveUser",
    method: "POST",
    data
  });
}
// 删除
export function removeUser(data) {
  return request({
    url: "/apis/demo/userAndEducation/removeUser", // 后端接口
    method: "post",
    data
  });
}
// 详情
export function getUserById(data) {
  return request({
    url: "/apis/demo/userAndEducation/getUserById", // 后端接口
    method: "POST",
    data
  });
}
// 批量查询
export function getListbycheck(data) {
  return request({
    url: "/apis/demo/user/listUserDemos",
    method: "POST",
    data
  });
}
// 列表所有信息
export function getpeoplemanageList(data) {
  return request({
    url: "/apis/demo/userAndEducation/listUsers",
    method: "POST",
    data
  });
}
// 获取所有省
export function getAllprovince(data) {
  return request({
    url: "/apis/demo/userAndEducation/listAddress",
    method: "POST",
    data
  });
}
// 部门
export function getdepartment(data) {
  return request({
    url: "/apis/demo/userAndEducation/listOmcOrgTree",
    method: "POST",
    data
  });
}
// 图片上传
export function uploadImg(data) {
  return request({
    url: this.$addUrlPerFix(process.env.VUE_APP_UPLOAD_URL),
    method: "POST",
    data
  });
}
//部门搜索
export function getdepartmentSearch(data) {
  return request({
    url: "/apis/demo/userAndEducation/listSearch",
    method: "POST",
    data
  });
}
